module.exports = __webpack_public_path__ + "img/team.dea98816.png";